export default "__VITE_ASSET__DGxVUwIU__"